/**
 * Replaces text patterns in DOM text nodes without affecting scripts, styles, or other sensitive elements.
 * @param element - The root element to start traversing from
 */
export function replaceTextInElement(element: HTMLElement): void {
  for (const node of Array.from(element.childNodes)) {
    if (node.nodeType === Node.TEXT_NODE) {
      // Replace m2 with m² (superscript 2)
      node.textContent = node.textContent?.replace(/\b(m2)\b/gi, 'm²') ?? null;
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.nodeName !== 'SCRIPT' &&
      node.nodeName !== 'STYLE'
    ) {
      replaceTextInElement(node as HTMLElement);
    }
  }
}

/**
 * Initializes text replacement on the document body.
 * Should be called after DOM is ready.
 */
export function initTextReplacer(): void {
  replaceTextInElement(document.body);
}
